import { useEffect } from "react";

import AppNotification from "shared/components/organisms/AppNotification";
import { useTopbarContext } from "shared/providers/Layout/hooks/useTopbarContext";

import { NotificationsContainer } from "./styles";

export const Notifications = () => {
  const { notificationsIsOpen, closeNotifications } = useTopbarContext();

  const handleClickOutside = (event: MouseEvent) => {
    if (
      (event?.target as HTMLDivElement)?.classList?.contains(
        "notifications-container",
      )
    )
      closeNotifications();
  };

  useEffect(() => {
    if (!notificationsIsOpen)
      return document.removeEventListener("mousedown", handleClickOutside);

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [notificationsIsOpen]);

  return (
    <NotificationsContainer
      show={notificationsIsOpen}
      className="notifications-container"
    >
      <AppNotification />
    </NotificationsContainer>
  );
};
